import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { ResourceUrlComponent } from '../resource-url/resource-url.component';
import * as $ from 'jquery';

@Component({
  selector: 'app-resources',
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.css']
})
export class ResourcesComponent implements OnInit {
  rowData =[];
  private gridApi;
   gridColumnApi;
   frameworkComponents;
  public getRowHeight;
  public link:any;
  tabToNextCell:any;
  defaultColDef = { resizable: true, cellStyle: {'white-space': 'normal','font-size':'14px','word-break': 'break-word'},sortable:true,filter:true };
  columnDefs = [
    {headerName: 'Resource', field: 'Resource', cellRenderer: function(params) {
      return '<a  tabindex="0" data-toggle="modal" data-target="#confirmModal" style="color:#0000EE;text-decoration:underline;cursor:pointer;">'+ params.data.Resource+'</a>'
    }},
    {headerName: 'Description', field: 'Description'},
    {headerName: 'Resource Type', field: 'Resource Type'},
    {headerName: 'Url',field:'Link',cellRenderer:'viewrenderer',valueGetter: function ( params ) {
      return params.data.Link;
    }}
];
  constructor(public http:HttpClient,public toastService:ToastrService) {
   }

  ngOnInit() { 
    this.frameworkComponents = {
      viewrenderer: ResourceUrlComponent
    };
    this.tabToNextCell = function tabToNextCell(params) {
      const nextCell = params.nextCellPosition;
      if (nextCell == null ) {
      return;
      } else {
      return nextCell;
      }
      }; 
    this.load();
    this.getRowHeight = function(params) {
      return params.data.rowHeight;
    };
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
    //this.gridApi.setDomLayout("autoHeight");
  }
  load(){
    this.http.get("assets/data/resources.json").subscribe((data:Array<Object>)=>{
      this.rowData = data;
    },error=>{
      this.toastService.error("Unable to load employment resources","Employment Resources");
    })
  }
  summaryclickEvent(event){
    if(event.column.colDef.headerName == 'Url' && event.data.defaultAction == 'view'){
      $("#confirmBox").click();
      this.link = event.data;
    }
    else if(event.column.colDef.headerName == 'Resource'){
      this.link = event.data;
    }
  }
  view(){
    window.open(this.link.Link);
    $("#dismiss").click();
  }
  focus(event){
    if(event.keyCode == 9){
      this.gridApi.ensureIndexVisible(this.gridApi.paginationGetCurrentPage()*10);
      let firstCol = this.gridColumnApi.getAllDisplayedColumns()[0];
      this.gridApi.ensureColumnVisible(firstCol);
      if(firstCol.gridOptionsWrapper.gridOptions.rowData.length == 0){
        return;
      }
      else{
        event.preventDefault();
        this.gridApi.setFocusedCell((this.gridApi.paginationGetCurrentPage()*10), firstCol);
      }
    }
    else{
      return;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/resources/resources.component.ts